/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Button, Flexed, ProgressBar } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';
import {
  calculateNFTWithdrawalTime,
  formatUSD,
  formatUSDNoDecimals,
  ULX,
  USDT
} from '../../helpers/helperFunctions';
import { Flex, Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { PackageTrading } from './Portfolio.types';
import { useRef } from 'react';

import { Link } from 'react-router-dom';
import { MANAGE_AKASHA_NODE, MY_HUBS } from '../../routes/routes';
import { Circle } from '../Ranking/RankingStyled';
import {
  Desktop,
  Mobile
} from '../MyTeamBackoffice/Structure/common/UserVerifications/UserVerification.styles';
import { WithdrawalItemDisabled } from './WithdrawalItemDisabled';
import { PortfolioItemDisabled } from './PortfolioItemDisabled';

export const PortfolioAkashaItem = ({
  item,
  transferAssetStatus
}: {
  item: PackageTrading;
  transferAssetStatus: boolean;
}) => {
  const { t } = useTranslation('my_hubs');

  const getDepositPercentage = (
    depositedAmount: number | null | undefined,
    depositLimit: number | null | undefined
  ) => {
    if (!depositedAmount || !depositLimit) {
      return 0;
    } else {
      return Math.round((depositedAmount / depositLimit) * 100);
    }
  };

  const showDisabledHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();

      if (days > 0) {
        return <WithdrawalItemDisabled />;
      }
    }
  };

  const showWithdrawNFTButton = () => {
    return (
      calculateNFTWithdrawalTime(item) && (
        <Flexed column alignEnd>
          <Button
            color='#ffffff'
            borderColor='#CC0000'
            background='#CC0000'
            wSM='100%'
            w='200px'
            onClick={() => {}}
            negative={false}>
            TRANSFERRED
          </Button>
        </Flexed>
      )
    );
  };

  const showDisabledBigWhaleHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();
      const hours = fromNow.hours();

      if (days === 0 && hours < 24) {
        return (
          <PortfolioItemDisabled
            title={t('disabled_hub_title')}
            subtitle='It may take up to 24 Hours for Hub NFT to Refresh.'
          />
        );
      }
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage
          image={item.image}
          isDisabled={calculateNFTWithdrawalTime(item)}>
          <H4 color={color.colors.neutral0}>{item.name}</H4>
        </HubImage>
        <Flexed column between>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {item.price} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('order_id')}:
                </CaptionText>
                <P1 bold>{item?.id}</P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('nft_id')}:
                </CaptionText>
                <P1 bold>{item?.nftId}</P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Status
                </CaptionText>
                <Flexed center>
                  <P3 bold caps>
                    {item?.depositedUsdtAmount ? t('active') : t('inactive')}
                  </P3>
                  <Circle
                    color={
                      item?.depositedUsdtAmount
                        ? color.colors.success500
                        : color.colors.error500
                    }
                  />
                </Flexed>
              </Td>

              <Td w='20%' wSM='50%'>
                {showWithdrawNFTButton()}
              </Td>
            </Tr>
          </div>

          {/* <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                amount minted
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(item?.mintedAmount || 0)} {item?.mintedTokenCurrency}
              </P1>
            </Td>
          </Tr> */}
          <Flexed center>
            <CaptionText caps bold color={color.colors.neutral500} mr='10'>
              amount minted:
            </CaptionText>
            <P1 bold>
              {' '}
              {formatUSD(item?.mintedAmount || 0)} {ULX}
            </P1>
          </Flexed>

          <Flexed rowSM>
            <Flexed column width='50%' widthSM='100%'>
              <Flexed between center>
                <Desktop style={{ width: '100%' }}>
                  <Flexed between center>
                    <Flexed center gap='5px'>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        DEPOSITED
                      </CaptionText>

                      <P2 semiBold>
                        {item?.depositedUsdtAmount
                          ? formatUSD(item?.depositedUsdtAmount)
                          : 0}{' '}
                        {USDT} / {formatUSD(item?.depositedCurrencyAmount)}{' '}
                        {ULX}
                      </P2>
                    </Flexed>

                    <Flexed center gap='5px'>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        Max deposit
                      </CaptionText>

                      <P2 semiBold>
                        {' '}
                        {item?.depositLimit ? formatUSD(item?.depositLimit) : 0}
                      </P2>
                    </Flexed>
                  </Flexed>
                </Desktop>
                <Mobile style={{ width: '100%' }}>
                  <Flexed between>
                    <Flexed column>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        DEPOSITED
                      </CaptionText>

                      <P2 semiBold>
                        {item?.depositedUsdtAmount
                          ? formatUSD(item?.depositedUsdtAmount)
                          : 0}{' '}
                        {USDT} / {formatUSD(item?.depositedCurrencyAmount)}{' '}
                        {item?.depositedTokenCurrency}
                      </P2>
                    </Flexed>

                    <Flexed column>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        Max deposit
                      </CaptionText>

                      <P2 semiBold>
                        {' '}
                        {item?.depositLimit ? formatUSD(item?.depositLimit) : 0}
                      </P2>
                    </Flexed>
                  </Flexed>
                </Mobile>
              </Flexed>

              <ProgressBar
                percentage={`${getDepositPercentage(
                  item?.depositedUsdtAmount,
                  item?.depositLimit
                )}%`}
                percentageLabel
                progressColor={'#25E8BA'}>
                <div></div>
                <span>
                  {' '}
                  {getDepositPercentage(
                    item?.depositedUsdtAmount,
                    item?.depositLimit
                  )}
                  %
                </span>
              </ProgressBar>
            </Flexed>
            <Flexed end width='50%' widthSM='100%'>
              <Link to={`${MANAGE_AKASHA_NODE}/${item.id}`}>
                <Button
                  condensed
                  mt='20'
                  w='auto'
                  p='0 16px'
                  disabled={
                    !item?.nftId || item?.depositedTokenCurrency === 'AK1111'
                  }>
                  Manage
                </Button>
              </Link>
            </Flexed>
          </Flexed>
        </Flexed>

        {calculateNFTWithdrawalTime(item)
          ? showDisabledHub(item)
          : showDisabledBigWhaleHub(item)}
      </BoxBig>
    </>
  );
};
